import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Toaster } from "sonner";
import { ArrowRight, BookOpen, Calendar, User } from "lucide-react";
import "@/App.css";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPosts();
  }, []);

  const fetchPosts = async () => {
    try {
      const res = await axios.get(`${API}/blog`);
      setPosts(res.data.posts);
    } catch { /* empty */ }
    finally { setLoading(false); }
  };

  return (
    <div className="app-container">
      <Toaster position="top-right" richColors />

      <header className="main-header">
        <Link to="/" className="logo-section" style={{ textDecoration: "none" }}>
          <img src="/logo.png" alt="Market Mop" className="blog-header-logo" />
          <div className="logo-text">
            <h1>Market Mop</h1>
            <p>Walmart Marketplace Bulk Retirement & CSV Exporter Tool</p>
          </div>
        </Link>
        <div className="header-actions">
          <Link to="/" className="header-btn btn-primary" style={{ textDecoration: "none", display: "inline-flex", alignItems: "center", gap: 6 }}>
            Try Free
          </Link>
        </div>
      </header>

      <div className="blog-hero" data-testid="blog-hero">
        <h1 className="blog-hero-title">Market Mop Blog</h1>
        <p className="blog-hero-subtitle">Tips, guides, and insights for Walmart Marketplace sellers</p>
      </div>

      <main className="blog-container" data-testid="blog-list">
        {loading ? (
          <div className="blog-loading">Loading posts...</div>
        ) : posts.length === 0 ? (
          <div className="blog-empty">No blog posts yet. Check back soon!</div>
        ) : (
          <div className="blog-grid">
            {posts.map((post, i) => (
              <Link to={`/blog/${post.slug}`} key={post.slug} className="blog-card" data-testid={`blog-card-${post.slug}`}>
                <div className="blog-card-content">
                  <div className="blog-card-meta">
                    <span className="blog-card-date">
                      <Calendar className="w-3.5 h-3.5" />
                      {new Date(post.created_at).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })}
                    </span>
                    <span className="blog-card-author">
                      <User className="w-3.5 h-3.5" />
                      {post.author}
                    </span>
                  </div>
                  <h2 className="blog-card-title">{post.title}</h2>
                  <p className="blog-card-excerpt">{post.excerpt}</p>
                  <div className="blog-card-cta">
                    <span>Read More</span>
                    <ArrowRight className="w-4 h-4" />
                  </div>
                  {post.meta_keywords?.length > 0 && (
                    <div className="blog-card-tags">
                      {post.meta_keywords.slice(0, 3).map(kw => (
                        <span key={kw} className="blog-tag">{kw}</span>
                      ))}
                    </div>
                  )}
                </div>
                {i === 0 && <div className="blog-card-featured-badge">Latest</div>}
              </Link>
            ))}
          </div>
        )}
      </main>

      <footer className="blog-footer">
        <div className="blog-footer-inner">
          <Link to="/" style={{ textDecoration: "none" }}>
            <img src="/logo.png" alt="Market Mop" className="blog-footer-logo" />
          </Link>
          <p className="blog-footer-text">MarketMop.com — The fastest way to manage your Walmart Marketplace inventory.</p>
          <div className="blog-footer-links">
            <Link to="/" data-testid="footer-home-link">Home</Link>
            <Link to="/blog" data-testid="footer-blog-link">Blog</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
